/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Pricing = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  // Array of pricing data
  // const pricingData = [
  //   { typology: "3 Bed Luxe", carpetArea: "1400" },
  //   { typology: "3 Bed Uber Luxe", carpetArea: "1675" },
  //   { typology: "4 Bed Luxe", carpetArea: "2200" },
  //   { typology: "4 Bed Uber Luxe", carpetArea: "2425" },
  //   { typology: "4 Bed Sky Mansion", carpetArea: "3000" },
  // ];

  return (
    <section className="section shadow-sm lazyloaded" id="pricing">
      <span className="section-link"></span>
      <h2 className="head text-capitalize text-center">
        {project} - Price Plan
      </h2>
      <div className="pricing-div text-center">
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>1 BHK</h3>
          <h4>508 Sq. Ft.</h4>
          <button
            class="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
        <div className="price-card ">
          <h3 style={{ fontSize: "1.5rem", marginBlock: "1rem" }}>2 BHK</h3>
          <h4>755 - 771 Sq. Ft.</h4>
          <button
            class="btn btn-sm btn-info effetGradient effectScale enqModal"
            onClick={() => handleShowModal("Price Breakup")}
          >
            Price Breakup
          </button>
        </div>
      </div>
      {/* <div className="prc-tbl">
        <table>
          <tr>
            <th>Typology</th>
            <th>Carpet Area (Sq.Ft.)</th>
            <th>Price</th>
          </tr>
          {pricingData.map((item, index) => (
            <tr key={index}>
              <td>{item.typology}</td>
              <td>{item.carpetArea} Sq. Ft.</td>
              <td>
                <button
                  className="btn btn-sm btn-info effetGradient effectScale enqModal"
                  onClick={() => handleShowModal("Price Breakup")}
                >
                  Price Breakup
                </button>
              </td>
            </tr>
          ))}
        </table>
      </div> */}
    </section>
  );
};

export default Pricing;
